import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    header: {
      display: "flex",
      alignItems: "center",
      gap: 20,
      marginTop: 40,
      marginBottom: 24
    },
    title: {},
    root: {
      marginTop: "24px",
      overflowX: "auto",
      width: "100%",
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: "2px",
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      },
      "& .MuiTableBody-root": {
        "& .MuiTableCell-root": {
          padding: "1.2rem 1.2rem"
        }
      },
      "& .MuiTableHead-root": {
        "& .MuiTableCell-root": {
          padding: "1.2rem 1.2rem "
        },
        "& .MuiTableCell-root:nth-child(-n+4)": {
          borderRight: `1px solid ${theme.palette.grey[300]}`
        }
      },
      "& .MuiTable-root": {
        overflowX: "auto",
        width: "100%"
      },
      "& tbody": {
        "& tr": {
          background: "white !important"
        },
        "& tr:last-child": {
          "& .MuiTableCell-root": {
            borderBottom: `1px solid ${theme.palette.grey[300]}`
          }
        },
        "&:hover": {
          "& tr": {
            background: "#E6F6F8 !important",
            "&:before": {
              width: "4px",
              height: "100%",
              content: "",
              position: "absolute",
              background: "#009FB8"
            }
          }
        }
      },
      "& tbody:nth-child(odd)": {
        "& tr": {
          background: "#F2FAFB !important"
        }
      }
    },
    selectLanguageField: {
      height: 36,
      width: 100,
      "& .MuiSelect-root": {
        padding: "0.8rem 1.2rem"
      }
    },
    tableContainer: {
      maxHeight: "60vh"
    },
    tableHeader: {
      height: "78px"
    },
    borderRight: {
      borderRight: `1px solid ${theme.palette.grey[300]}`
    },
    noBorderRight: {
      borderRight: "none !important"
    },
    flexCenter: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    text: {
      fontSize: "1.4rem"
    },
    checkBox: {
      width: "fit-content",
      marginTop: "0.9rem",
      marginBottom: 0
    },
    col60: {
      width: 60,
      minWidth: 60
    },
    col80: {
      width: 80,
      minWidth: 80
    },
    col90: {
      width: 90,
      minWidth: 90
    },
    col150: {
      width: 150,
      minWidth: 150
    },
    col120: {
      width: 120,
      minWidth: 120
    },
    col280: {
      width: 280,
      minWidth: 280
    },
    col320: {
      width: 320,
      minWidth: 320
    },
    cellFreeze2_Customer: {
      position: "sticky",
      left: 0,
      background: "inherit",
      zIndex: 3
    },
    cellFreeze3_Customer: {
      position: "sticky",
      left: 90,
      background: "inherit",
      zIndex: 3
    },
    cellFreeze4_Customer: {
      position: "sticky",
      left: 240,
      background: "inherit",
      zIndex: 3
    },
    cellFreeze1_Admin: {
      position: "sticky",
      left: 0,
      background: "inherit",
      zIndex: 3
    },
    cellFreeze2_Admin: {
      position: "sticky",
      left: 69,
      background: "inherit",
      zIndex: 3
    },
    cellFreeze3_Admin: {
      position: "sticky",
      left: 159,
      background: "inherit",
      zIndex: 3
    },
    cellFreeze4_Admin: {
      position: "sticky",
      left: 309,
      background: "inherit",
      zIndex: 3
    },
    btnPrint: {
      fontSize: "1.6rem",
      lineHeight: "24px",
      height: 32
    },
    soNO: {
      color: theme.palette.info.main
    },
    statusReady: {
      width: "fit-content",
      padding: "0.1rem 1rem",
      borderRadius: 10,
      margin: "0 auto",
      background: theme.palette.background.default,
      color: "#007BFF"
    },
    statusInProgress: {
      width: "fit-content",
      padding: "0.1rem 1rem",
      borderRadius: 10,
      margin: "0 auto",
      background: "#FCF2E6",
      color: "#FD7E14"
    },
    statusCancel: {
      width: "fit-content",
      padding: "0.1rem 1rem",
      borderRadius: 10,
      margin: "0 auto",
      background: theme.palette.grey[200],
      color: theme.palette.grey[600]
    },
    estimatedDate: {
      color: theme.palette.info.dark
    },
    paginateFooter: {
      padding: "1.2rem 0 15rem 0"
    },
    flex: { display: "flex", alignItems: "center" },
    zIndex1: { zIndex: 1 }
  }),
  {
    name: "OrderConfirmListTable"
  }
);

export default useStyles;
